// extracted by mini-css-extract-plugin
export default {"content":"styles_content__jkfrd","actionLink":"styles_actionLink__oEWWt"};